import { RankData } from '../rank-card.service'

export const MockUseRecordType3: { view_infos: RankData[] } = {
  'view_infos': [
    {
      'name': '微信',
      'value': 6
    },
    {
      'name': 'QQ',
      'value': 2
    },
    {
      'name': 'TIM',
      'value': 2
    }
  ]
}
